import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

const BASE = "/specialist-visit-sessions";
const REPORT_BASE = "/specialist-visit-reports";

// --- Reason Definitions ---

async function getReasonDefinitions() {
  const response = await http
    .getData("/specialist-visit-reason-definitions")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- Session CRUD ---

async function getSessions(params?: any) {
  const response = await http
    .getDataParam(BASE, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getSession(id: number) {
  const response = await http
    .getData(`${BASE}/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function createSession(data: any) {
  const response = await http
    .postData(BASE, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateSession(id: number, data: any) {
  const response = await http
    .putData(`${BASE}/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteSession(id: number) {
  const response = await http
    .deleteData(`${BASE}/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- Import Pasien ---

async function importPasien(sessionId: number) {
  const response = await http
    .postData(`${BASE}/${sessionId}/import-pasien`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function pullSoap(sessionId: number) {
  const response = await http
    .postData(`${BASE}/${sessionId}/pull-soap`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- Observation CRUD ---

async function createObservation(sessionId: number, data: any) {
  const response = await http
    .postData(`${BASE}/${sessionId}/observations`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateObservation(sessionId: number, obsId: number, data: any) {
  const response = await http
    .putData(`${BASE}/${sessionId}/observations/${obsId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getAvailablePatients(sessionId: number, term?: string) {
  const params: any = {};
  if (term) params.term = term;
  const response = await http
    .getDataParam(`${BASE}/${sessionId}/available-patients`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteObservation(sessionId: number, obsId: number) {
  const response = await http
    .deleteData(`${BASE}/${sessionId}/observations/${obsId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- 3-Tier Signing ---

async function signPencatat(sessionId: number, password: string) {
  const response = await http
    .putData(`${BASE}/${sessionId}/sign-pencatat`, { password })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signKepalaRuang(sessionId: number, password: string) {
  const response = await http
    .putData(`${BASE}/${sessionId}/sign-kepala-ruang`, { password })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signApprover(sessionId: number, password: string) {
  const response = await http
    .putData(`${BASE}/${sessionId}/sign-approver`, { password })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- Reports ---

async function getMonthlyReport(bulan: number, tahun: number) {
  const response = await http
    .getDataParam(`${REPORT_BASE}/monthly`, { params: { bulan, tahun } })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function generateMonthlyReport(bulan: number, tahun: number) {
  const response = await http
    .postData(`${REPORT_BASE}/monthly/generate`, { bulan, tahun })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getScorecards(bulan: number, tahun: number) {
  const response = await http
    .getDataParam(`${REPORT_BASE}/scorecards`, { params: { bulan, tahun } })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function generateScorecards(bulan: number, tahun: number) {
  const response = await http
    .postData(`${REPORT_BASE}/scorecards/generate`, { bulan, tahun })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getDashboard(bulan?: number, tahun?: number) {
  const response = await http
    .getDataParam(`${REPORT_BASE}/dashboard`, { params: { bulan, tahun } })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- PDF ---

function getPdfUrl(sessionId: number): string {
  return `${http.apiUrl}${BASE}/${sessionId}/pdf`;
}

export default {
  getReasonDefinitions,
  getSessions,
  getSession,
  createSession,
  updateSession,
  deleteSession,
  importPasien,
  pullSoap,
  getAvailablePatients,
  createObservation,
  updateObservation,
  deleteObservation,
  signPencatat,
  signKepalaRuang,
  signApprover,
  getMonthlyReport,
  generateMonthlyReport,
  getScorecards,
  generateScorecards,
  getDashboard,
  getPdfUrl,
};
